/**
 * Wzory zgłoszenia przyłączenia mikroinstalacji u operatorów sieci (OSD).
 *
 * ═══ TO JEST PLIK DO RĘCZNEJ EDYCJI ═══
 * Każdy wzór ma datę wersji i adres źródła. Kopie leżą w `public/osd/`, bo przeglądarka nie pobierze PDF-u
 * prosto ze strony OSD (CORS). Raz w miesiącu porównać wzór na stronie OSD z kopią; nowa wersja = nowa kopia
 * i przegląd mapowania pól w `lib/osd/<klucz>.js` (tam też ścieżki kopii). Rozpoznanie formularzy wszystkich OSD:
 * `VV/dane_badawcze/osd_zgloszenia/inwentaryzacja_2026-10-07.md`.
 *
 * Wspólna treść wzoru: rozporządzenie MKiŚ z 31.05.2023 (Dz.U. 2023 poz. 1098). Wcześniejsze
 * rozporządzenie z 30.11.2021 (Dz.U. 2021 poz. 2343) straciło moc 1.04.2023 (sprawdzone 2026-10-14).
 */
export const OSD = [
  {
    klucz: 'enea',
    nazwa: 'Enea Operator',
    krotko: 'Enea',
    obszar: 'zachód i północny zachód',
    kolor: '#0ea5e9',
    logo: '/osd/logo-enea.svg',
    proporcja: 1.85,
    aktywny: true,
    wersja: 'WZ-MI, wersja edytowalna z 21.05.2026',
    zrodlo: 'https://www.operator.enea.pl/uslugidystrybucyjne/dladomu/plikidopobrania',
    wysylka: 'przez portal przylaczenia.operator.enea.pl albo e-mailem na kontakt@operator.enea.pl (skan z podpisem lub podpis kwalifikowany)',
  },
  {
    klucz: 'pge',
    nazwa: 'PGE Dystrybucja',
    krotko: 'PGE',
    obszar: 'wschód i centrum',
    kolor: '#6366f1',
    logo: '/osd/logo-pge.png',
    proporcja: 3.67,
    aktywny: true,
    // Płaski PDF bez pól: wartości drukujemy w zmierzonych miejscach (`lib/osd/pge.js`).
    wersja: 'W-ZM (bez daty w pliku) i specyfikacja magazynu WZM-ME',
    zrodlo: 'https://pgedystrybucja.pl/przylaczenia/procedury-przylaczeniowe/dokumenty-do-pobrania',
  },
  {
    klucz: 'tauron',
    nazwa: 'Tauron Dystrybucja',
    krotko: 'Tauron',
    obszar: 'południe',
    kolor: '#d946ef',
    logo: '/osd/logo-tauron.svg',
    proporcja: 1.21,
    aktywny: true,
    // Kopia w `public/osd/` bez szyfrowania (oryginał: hasło właściciela, wypełnianie pól dozwolone).
    wersja: 'ZM wer. 4 (plik z 1.10.2025)',
    zrodlo: 'https://www.tauron-dystrybucja.pl/przylaczenie-do-sieci/przylaczenie/mikroinstalacja',
    wysylka: 'pocztą na skrytkę pocztową nr 2708, 40-337 Katowice, przez Elektroniczną Obsługę Klienta (tauron-dystrybucja.pl/formularz) albo formularzem ZM online',
  },
  {
    klucz: 'energa',
    nazwa: 'Energa-Operator',
    krotko: 'Energa',
    obszar: 'północ',
    kolor: '#10b981',
    logo: '/osd/logo-energa.svg',
    proporcja: 2.41,
    aktywny: true,
    wersja: 'wniosek i zgłoszenie mikroinstalacji, wersja obowiązująca od 15.07.2026 (z załącznikami A, B i C)',
    zrodlo: 'https://energa-operator.pl/dokumenty-i-formularze/przylaczenia-do-sieci/wytworca/mikroinstalacja',
    wysylka: 'skanem przez formularz na energa-operator.pl albo pocztą do Energa-Operator S.A., ul. Marynarki Polskiej 130, 80-557 Gdańsk lub do oddziału',
  },
  { klucz: 'stoen', nazwa: 'Stoen Operator', krotko: 'Stoen', obszar: 'Warszawa', kolor: '#f59e0b', logo: '/osd/logo-stoen.svg', proporcja: 1.95, aktywny: false },
]

/*
 * `aktywny`: wzór PDF przejrzany i wypełniany (moduł w `lib/osd/`). U pozostałych narzędzie daje ściągę danych
 * i certyfikat. `kolor` to kolor legendy na mapie VoltValue, NIE barwy marki operatora.
 *
 * Logotypy ze stron operatorów (pobrane 2026-10-07 za zgodą właściciela, tylko do oznaczenia operatora):
 * Enea z nagłówka operator.enea.pl (SVG w kodzie strony), Tauron z tauron-dystrybucja.pl (pole widoku
 * przycięte do znaku), PGE z pgedystrybucja.pl (PNG), Energa z energa-operator.pl, Stoen ze stoen.pl.
 * `proporcja` = szerokość / wysokość logo, do plakietek na mapie.
 */

/** Czcionka z polskimi znakami do pól formularza (Liberation Sans, licencja SIL OFL, `public/osd/LICENSE_LIBERATION`). */
export const CZCIONKA_FORMULARZA = '/osd/LiberationSans-Regular.ttf'
